import { BreadCrumbKeys, BreadcrumbTypes, BreadCrumLabels, RootPath } from "../../../../../../components/breadCrumb/enum";
import { NavigatioStateType } from "../../../../../../utils/enums/navigatetionState";

const actions = `${BreadCrumbKeys.ACTIONS}=${BreadcrumbTypes.BLOCK_All_ACTIONS}`
const detailListPath = `${BreadCrumbKeys.ROOT}=${RootPath.SCHEDULE}-${BreadCrumLabels.SCHEDULE},${RootPath.SCHEDULE_DETAIL_LIST}-${BreadCrumLabels.SCHEDULE_DETAIL_LIST}-{id},${RootPath.SCHEDULE_DETAIL}-${BreadCrumLabels.SCHEDULE_DETAIL}-{id}-{schedule_state}`
const detailUserScheduleListPath = `${BreadCrumbKeys.ROOT}=${RootPath.USER_SCHEDULE}-${BreadCrumLabels.USER_SCHEDULE},${RootPath.USER_SCHEDULE_DETAIL}-${BreadCrumLabels.USER_SCHEDULE_DETAIL}-{id}-{schedule_state}`


const navigateOption = {
    [NavigatioStateType.SCHEDULE]: {
        navigate: detailListPath,
        actionPlan: '/dashboard/calendar/action-plan',
        recurrence:'/dashboard/calendar/recurrence',
        reportFolio: '/dashboard/calendar/report-folio-list'
    },
    [NavigatioStateType.USER_SCHEDULE]: {
        navigate: detailUserScheduleListPath,
        actionPlan: '/dashboard/schedule-user/action-plan',
        recurrence:'/dashboard/schedule-user/recurrence',
        reportFolio: '/dashboard/schedule-user/report-folio-list'
    },
}
export { detailListPath, detailUserScheduleListPath, actions, navigateOption }
